var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUserOctagon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.5099 6.35L13.5699 2.92C12.5999 2.36 11.3999 2.36 10.4199 2.92L4.48992 6.35C3.51992 6.91 2.91992 7.95 2.91992 9.08V15.92C2.91992 17.04 3.51992 18.08 4.48992 18.65L10.4299 22.08C11.3999 22.64 12.5999 22.64 13.5799 22.08L19.5199 18.65C20.4899 18.09 21.0899 17.05 21.0899 15.92V9.08C21.0799 7.95 20.4799 6.92 19.5099 6.35ZM11.9999 7.84C13.2899 7.84 14.3299 8.88 14.3299 10.17C14.3299 11.46 13.2899 12.5 11.9999 12.5C10.7099 12.5 9.66992 11.46 9.66992 10.17C9.66992 8.89 10.7099 7.84 11.9999 7.84ZM14.6799 17.16H9.31992C8.50992 17.16 8.03992 16.26 8.48992 15.59C9.16992 14.58 10.4899 13.9 11.9999 13.9C13.5099 13.9 14.8299 14.58 15.5099 15.59C15.9599 16.25 15.4799 17.16 14.6799 17.16Z",
    fill: "#292D32"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserOctagon);
export default __webpack_public_path__ + "static/media/user-octagon.9f6cf0ba50b4eae23b5fcc79165284e5.svg";
export { ForwardRef as ReactComponent };